<p>
    MTA Country is a game about traversing the NYC subway, themed around the
    cart levels in Donkey Kong Country. I was hired by Everyday Arcade to take a
    prototype and finish developing the rest of the game.
</p>